import React from 'react';
import dimensionen from '../../db/dimensionen.json';
import {Field} from "redux-form";

export default function DimensionSelect({ index, name }) {
  return (
    <Field
      name={`${index}.${name}`}
      className="form-control"
      component={({
        input: { onChange, name, value },
        label,
        meta,
        className,
      }) => (
        <select
          name={name}
          onChange={onChange}
          value={value}
          className={className}
        >
          {dimensionen.map(key => (
            <option value={key} key={key}>
              {key + ' cm'}
            </option>
          ))}
        </select>
      )}
    />
  );
}



// WEBPACK FOOTER //
// ./src/components/inputs/DimensionSelect.js